!function(t,e){var o,n,p,r;e.__SV||(window.posthog && window.posthog.__loaded)||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}p||((p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",p.onerror=function(){p=null},(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r));var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],Object.defineProperty(u,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e}}),Object.defineProperty(u.people,"toString",{configurable:!0,enumerable:!0,writable:!0,value:function(){return u.toString(1)+".people (stub)"}}),o="init capture register register_once register_for_session unregister opt_out_capturing has_opted_out_capturing opt_in_capturing reset isFeatureEnabled getFeatureFlag getFeatureFlagPayload reloadFeatureFlags group identify setPersonProperties setPersonPropertiesForFlags resetPersonPropertiesForFlags setGroupPropertiesForFlags resetGroupPropertiesForFlags resetGroups onFeatureFlags addFeatureFlagsHandler onSessionId getSurveys getActiveMatchingSurveys renderSurvey canRenderSurvey getNextSurveyStep".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
(function () {
  function cookie(name) {
    var match = document.cookie.match(new RegExp('(?:^|; )' + name.replace(/[$()*+./?[\\\]^{|}]/g, '\\$&') + '=([^;]*)'));
    return match ? decodeURIComponent(match[1]) : '';
  }

  function money(cents) {
    var n = Number(cents);
    return isFinite(n) ? n / 100 : undefined;
  }

  /* Analytics is never allowed to throw into the theme. Every capture is a
     dead end for errors: the theme calls these from inside add-to-cart and
     remove-line, where an escaping error leaves the item on the server and
     the drawer unpainted -- a dead button, from the shopper's side. */
  function capture(event, properties) {
    if (!window.posthog || typeof posthog.capture !== 'function') return;
    try {
      posthog.capture(event, properties || {});
    } catch (err) {}
  }

  /* Same contract at the public boundary, for the DOM reads and fetches that
     do not go through capture(). */
  function safe(fn, fallback) {
    return function () {
      try {
        return fn.apply(this, arguments);
      } catch (err) {
        return fallback;
      }
    };
  }

  function fromLine(item) {
    if (!item) return {};
    return {
      cart_id: item.cart_id,
      product_id: item.product_id != null ? String(item.product_id) : undefined,
      handle: item.handle || undefined,
      sku: item.sku || undefined,
      category: item.product_type || undefined,
      name: item.product_title || item.title,
      brand: item.vendor || undefined,
      variant: item.variant_title || undefined,
      price: money(item.final_price != null ? item.final_price : item.price),
      quantity: item.quantity,
      url: item.url,
      image_url: item.image || undefined
    };
  }

  function fromRow(row) {
    if (!row) return {};
    var nameEl = row.querySelector('.cart-item__name');
    return {
      product_id: row.getAttribute('data-ph-product-id') || undefined,
      handle: row.getAttribute('data-ph-handle') || undefined,
      sku: row.getAttribute('data-ph-sku') || undefined,
      name: row.getAttribute('data-ph-title') || (nameEl && nameEl.textContent.trim()) || undefined,
      variant: row.getAttribute('data-ph-variant') || undefined,
      price: row.getAttribute('data-ph-product-price') ? Number(row.getAttribute('data-ph-product-price')) : undefined,
      url: nameEl && nameEl.getAttribute('href')
    };
  }

  function identifyAndAlias() {
    var shopifyVisitor = cookie('_shopify_y');
    if (shopifyVisitor) {
      posthog.register({ shopify_client_id: shopifyVisitor });
      posthog.alias(shopifyVisitor);
    }
    var phCustomer = window.__posthogCustomer;
    if (phCustomer && phCustomer.id) {
      posthog.identify(String(phCustomer.id), {
        email: phCustomer.email,
        first_name: phCustomer.first_name,
        last_name: phCustomer.last_name
      });
    }
    var phArticle = window.__posthogArticle;
    if (phArticle && phArticle.handle) {
      posthog.register_for_session({
        last_article_handle: phArticle.handle,
        last_blog_handle: phArticle.blog_handle || undefined
      });
    }
  }

  function pageEvents() {
    if (pageEvents.done) return;
    var pageNode = document.getElementById('posthog-ecommerce');
    if (!pageNode || !pageNode.textContent) {
      pageEvents.done = true;
      return;
    }
    try {
      var page = JSON.parse(pageNode.textContent);
      var events = (page && page.events) || [];
      for (var i = 0; i < events.length; i++) {
        if (events[i] && events[i].event) capture(events[i].event, events[i].properties);
      }
    } catch (e) {}
    bindCrossSellViewed();
    pageEvents.done = true;
  }

  function bindCrossSellViewed() {
    function emit(el) {
      if (!el || el.getAttribute('data-ph-cross-viewed')) return;
      el.setAttribute('data-ph-cross-viewed', '1');
      var placement = el.getAttribute('data-ph-cross-sell') || 'cart';
      var products = [];
      el.querySelectorAll('[data-ph-handle]').forEach(function (node) {
        var h = node.getAttribute('data-ph-handle');
        if (!h) return;
        products.push({
          handle: h,
          product_id: node.getAttribute('data-ph-product-id') || undefined,
          name: node.getAttribute('data-ph-title') || undefined
        });
      });
      capture('Cross Sell Viewed', {
        placement: placement,
        list_id: placement,
        products: products
      });
    }
    function hasOffer(el) {
      return el.querySelector(
        'a[href*="/products/"], [data-add], .quick-add__submit, [data-zcart-add], .card-wrapper'
      );
    }
    document.querySelectorAll('[data-ph-cross-sell], [data-zcart-cross]').forEach(function (el) {
      if (hasOffer(el)) {
        emit(el);
        return;
      }
      var obs = new MutationObserver(function () {
        if (!hasOffer(el)) return;
        emit(el);
        obs.disconnect();
      });
      obs.observe(el, { childList: true, subtree: true });
    });
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-add], [name="add"], .product-form__submit, .quick-add__submit')) return;
    var link = e.target.closest('a[href*="/products/"]');
    if (!link) return;
    var card = e.target.closest('.zshop-card, .card-wrapper, .product-card-wrapper');
    var props = {
      name: undefined,
      url: link.href,
      product_id: card && card.getAttribute('data-ph-product-id') || undefined,
      handle: card && card.getAttribute('data-ph-handle') || undefined,
      price: card && card.getAttribute('data-ph-product-price') ? Number(card.getAttribute('data-ph-product-price')) : undefined,
      size: card && card.getAttribute('data-chosen') || undefined,
      size_changed: card && card.getAttribute('data-ph-shopper-pick') === '1',
      pick_count: card ? Number(card.getAttribute('data-ph-picks') || 0) : undefined
    };
    var cross = e.target.closest('.zcross__row, [data-ph-cross-sell]');
    if (cross) {
      var placement = cross.getAttribute('data-ph-cross-sell')
        || (cross.closest('[data-ph-cross-sell]') && cross.closest('[data-ph-cross-sell]').getAttribute('data-ph-cross-sell'))
        || 'cart';
      props.source = placement === 'pdp' ? 'pdp-cross-sell' : 'cross-sell';
      props.placement = placement;
      props.product_id = cross.getAttribute('data-ph-product-id') || props.product_id;
      props.handle = cross.getAttribute('data-ph-handle') || props.handle;
      props.name = cross.getAttribute('data-ph-title') || props.name;
      props.price = cross.getAttribute('data-ph-product-price')
        ? Number(cross.getAttribute('data-ph-product-price'))
        : props.price;
    }
    var title = card && card.querySelector('.zshop-card__title, .card__heading, .card-information__text');
    if (title) props.name = title.textContent.trim();
    else if (link.textContent) props.name = link.textContent.trim();
    capture('Product Clicked', props);
    if (props.source === 'cross-sell' || props.source === 'pdp-cross-sell') {
      capture('Cross Sell Clicked', props);
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.querySelector) return;
    var input = form.querySelector('input[name="q"]');
    if (!input || !input.value) return;
    capture('Products Searched', { query: input.value });
  });

  var api = {
    capture: capture,
    added: function (item, extra) {
      try {
        var props = fromLine(item);
        if (extra) {
          for (var key in extra) {
            if (Object.prototype.hasOwnProperty.call(extra, key) && extra[key] != null) {
              props[key] = extra[key];
            }
          }
        }
        capture('Product Added', props);
        if (props.source === 'cross-sell' || props.source === 'pdp-cross-sell') {
          capture('Cross Sell Added', props);
        }
      } catch (err) {
        capture('Product Added', extra || {});
        if (extra && (extra.source === 'cross-sell' || extra.source === 'pdp-cross-sell')) {
          capture('Cross Sell Added', extra);
        }
      }
    },
    removedFromRow: function (row) {
      capture('Product Removed', fromRow(row));
    },
    cartViewed: function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          capture('Cart Viewed', {
            cart_id: cart.token,
            products: (cart.items || []).map(fromLine)
          });
        })
        .catch(function () {});
    },
    productsFromRoot: function (root) {
      if (!root) return [];
      var cards = root.querySelectorAll('.zshop-card[data-ph-product-id]');
      var out = [];
      for (var i = 0; i < cards.length && out.length < 20; i++) {
        var card = cards[i];
        if (card.classList.contains('zshop-card--off')) continue;
        var group = card.closest('[data-zshop-group]');
        if (group && group.classList.contains('is-hidden')) continue;
        var title = card.querySelector('.zshop-card__title');
        out.push({
          product_id: card.getAttribute('data-ph-product-id'),
          handle: card.getAttribute('data-ph-handle') || undefined,
          name: title ? title.textContent.trim() : undefined,
          price: card.getAttribute('data-ph-product-price')
            ? Number(card.getAttribute('data-ph-product-price'))
            : undefined,
          position: out.length + 1
        });
      }
      return out;
    },
    listFiltered: function (opts) {
      if (!opts) return;
      var payload = {
        list_id: opts.list_id,
        category: opts.category,
        filters: opts.filters || [],
        products: opts.products || []
      };
      if (opts.result_count != null) payload.result_count = opts.result_count;
      capture('Product List Filtered', payload);
    }
  };

  window.zodiacPosthog = {
    capture: safe(api.capture),
    added: safe(api.added),
    removedFromRow: safe(api.removedFromRow),
    cartViewed: safe(api.cartViewed),
    productsFromRoot: safe(api.productsFromRoot, []),
    listFiltered: safe(api.listFiltered)
  };

  posthog.init('phc_uM3cnGUozg9a2ogdnLnpwjmVUaZGY4G2Xt4FxFsWU9x7', {
    api_host: 'https://us.i.posthog.com',
    defaults: '2026-05-30',
    loaded: function () {
      try { identifyAndAlias(); } catch (err) {}
      pageEvents();
    }
  });

  if (window.posthog && posthog.__loaded) pageEvents();

  (function bindFingerCalc() {
    var root = document.getElementById('zCalc');
    if (!root || root.dataset.phBound) return;
    root.dataset.phBound = '1';

    function unit() {
      var picked = root.querySelector('input[name="zc-unit"]:checked');
      return picked ? picked.value : 'lbs';
    }

    function resultPayload() {
      var bwKg = parseFloat(root.dataset.bw);
      var maxKg = parseFloat(root.dataset.max);
      var ratio = bwKg > 0 && isFinite(maxKg) ? Math.round((maxKg / bwKg) * 100) / 100 : undefined;
      return {
        calculator: 'finger-strength',
        unit: unit(),
        grade: root.dataset.grade || undefined,
        ratio: ratio,
        bw_kg: isFinite(bwKg) ? Math.round(bwKg) : undefined,
        max_kg: isFinite(maxKg) ? Math.round(maxKg) : undefined
      };
    }

    var lastGrade = '';
    function captureCalculated() {
      var result = document.getElementById('zc-result');
      var grade = (root.dataset.grade || '').trim();
      if (result && result.hidden) return;
      if (!grade || grade === lastGrade) return;
      lastGrade = grade;
      capture('Calculator Calculated', resultPayload());
    }

    if (typeof IntersectionObserver === 'function') {
      var io = new IntersectionObserver(function (entries) {
        if (!entries[0] || !entries[0].isIntersecting) return;
        capture('Calculator Viewed', { calculator: 'finger-strength' });
        io.disconnect();
      }, { threshold: 0.15 });
      io.observe(root);
    } else {
      capture('Calculator Viewed', { calculator: 'finger-strength' });
    }

    var gradeEl = document.getElementById('zc-grade');
    if (gradeEl && typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        setTimeout(captureCalculated, 0);
      }).observe(gradeEl, { childList: true, characterData: true, subtree: true });
    }

    var go = document.getElementById('zc-go');
    if (go) {
      go.addEventListener('click', function () {
        setTimeout(captureCalculated, 10);
      });
    }
    ['zc-bw', 'zc-max'].forEach(function (id) {
      var el = document.getElementById(id);
      if (!el) return;
      el.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') setTimeout(captureCalculated, 0);
      });
    });
    root.querySelectorAll('input[name="zc-unit"]').forEach(function (radio) {
      radio.addEventListener('change', function () {
        capture('Calculator Unit Changed', { calculator: 'finger-strength', unit: radio.value });
        setTimeout(captureCalculated, 0);
      });
    });
  })();
})();
